import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import SimpleReactValidator from "simple-react-validator";
import { Col, Row, Form, Spinner, Dropdown } from "react-bootstrap-v5";
import { SubAdminService } from "../../Services/SubAdminService";
import MultiSelect from "../../Components/MultiNestedSelect/MultiNestedSelect";
import { useHistory, useLocation } from "react-router-dom";
import { access, departments } from "./accessObj";
import { BiArrowFromTop } from "react-icons/bi";
import { retailerService } from "../../Services";

export const AddSubAdmin = () => {
  const [, setForceUpdate] = useState("");
  const [loader, setLoader] = useState(false);
  const [retailerlist, setRetailerlist] = useState([]);
  const [state, setState] = useState({
    full_name: "",
    employee_name: "",
    email: "",
    password: "",
    role: "",
    access: null,
    sub_employees: [],
  });
  const history = useHistory();

  const location = useLocation();
  const adminlist = location?.state?.adminList || [];

  const salesman = adminlist.filter((item, index) => {
    return item.role === "sales";
  });

  const marketplacedata = retailerlist.filter((item, index) => {
    return item.type === "marketplace";
  });

  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSelectChange = (e) => {
    setState({ ...state, [e.name]: e.value });
  };

  const getRetailer = async () => {
    await retailerService
      .getRetailer()
      .then((res) => {
        setRetailerlist(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getRetailer();
  }, []);

  const handleSubmit = () => {
    let validate = Validator.current.allValid();
    let Permission = ["add", "edit", "view", "delete"];
    if (validate) {
      let params = { ...state };

      let acc = [];
      params.access.map((e) => {
        if (e.sub_item && e.sub_item.length) {
          e.sub_item.map((el) => {
            if (el.sub_item) {
              el.sub_item.map((ej) => {
                if (ej.sub_item) {
                  ej.sub_item.map((ep) => {
                    acc.push({
                      item_id: ep.item_id,
                      permissions: ep.permissions,
                    });
                  });
                } else {
                  acc.push({
                    item_id: ej.item_id,
                    permissions: ej.permissions,
                  });
                }
              });
            } else {
              acc.push({
                item_id: el.item_id,
                permissions: el.permissions,
              });
            }
          });
        } else {
          acc.push({
            item_id: e.item_id,
            permissions: e.permissions,
          });
        }
      });
      params.access = acc;
      setLoader(true);

      if (state.role !== "sales_manager") {
        delete params.sub_employees;
      }
      if (state.role !== "marketplace_handler") {
        delete params.retailers;
      }

      SubAdminService.addSubAdmin(params).then((res) => {
        if (res.status) {
          toast.success(res.message);
          history.push("/sub-admin-list");
          setLoader(false);
        } else {
          setLoader(false);
          toast.error(res.msg);
        }
      });
    } else {
      Validator.current.showMessages();
    }
  };

  return (
    <div>
      <div className="row" style={{ width: "50%" }}>
        <div className="card">
          <div className="card-body">
            <Form autoComplete="off">
              <Row className="p-3">
                {/* full_name  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="full_name"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Name"
                    value={state.full_name}
                  />
                  {Validator.current.message(
                    "Name",
                    state.full_name,
                    "required",
                    {
                      className: "text-danger",
                    }
                  )}
                </Col>

                {/* email  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Email"
                    value={state.email}
                    autoComplete="new-password"
                  />
                  {Validator.current.message("Email", state.email, "required", {
                    className: "text-danger",
                  })}
                </Col>

                {/* Code  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="employee_name"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Code"
                    value={state.employee_name}
                  />
                  {Validator.current.message(
                    "Name",
                    state.employee_name,
                    "required",
                    {
                      className: "text-danger",
                    }
                  )}
                </Col>

                {/* role  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Department</Form.Label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        // height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                    }}
                    placeHolder="Select Department"
                    onChange={(e) =>
                      handleSelectChange({ name: "role", value: e.value })
                    }
                    options={departments}
                  />
                  {Validator.current.message(
                    "Department",
                    state.role,
                    "required",
                    { className: "text-danger" }
                  )}
                </Col>

                {state.role === "sales_manager" && (
                  <Col md={6} className="mb-3">
                    <Form.Label>Sales Employee</Form.Label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      getOptionLabel={(e) => e.full_name}
                      getOptionValue={(e) => e.employee_name}
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          maxHeight: "33px",
                          overflowY: "auto",
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: "150px",
                          overflowY: "auto",
                        }),
                      }}
                      placeholder="Select Sales Manager"
                      onChange={(selectedOptions) =>
                        setState((prevState) => ({
                          ...prevState,
                          sub_employees: selectedOptions.map(
                            (option) => option.employee_name
                          ),
                        }))
                      }
                      options={salesman}
                      value={salesman.filter((option) =>
                        state.sub_employees.includes(option.employee_name)
                      )}
                    />
                    {Validator.current.message(
                      "sub_employees",
                      state.sub_employees,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </Col>
                )}

                {state.role === "marketplace_handler" && (
                  <Col md={6} className="mb-3">
                    <Form.Label>Marketplace</Form.Label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      getOptionLabel={(e) => e.retailer_name}
                      getOptionValue={(e) => e._id}
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          maxHeight: "33px",
                          overflowY: "auto",
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: "150px",
                          overflowY: "auto",
                        }),
                      }}
                      placeholder="Select Marketplace"
                      onChange={(selectedOptions) =>
                        setState((prevState) => ({
                          ...prevState,
                          retailers: selectedOptions.map(
                            (option) => option._id
                          ),
                        }))
                      }
                      options={marketplacedata}
                      // value={marketplacedata?.filter((option) =>
                      //   state.marketplace_handler.includes(option._id)
                      // )}
                      value={marketplacedata?.filter(
                        (option) =>
                          Array.isArray(state.retailers) &&
                          state.retailers.includes(option._id)
                      )}
                    />
                    {Validator.current.message(
                      "retailers",
                      state.retailers,
                      "required",
                      {
                        className: "text-danger",
                      }
                    )}
                  </Col>
                )}

                {/* password  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Password"
                    autoComplete="new-password"
                    value={state.password}
                  />
                  {Validator.current.message(
                    "Password",
                    state.password,
                    "required",
                    {
                      className: "text-danger",
                    }
                  )}
                </Col>

                {/* access control  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Access Control</Form.Label>
                  <MultiSelect
                    name="access"
                    options={access}
                    placeHolder="Select Access Control"
                    value={state.access}
                    onChange={handleSelectChange}
                  />
                  {Validator.current.message(
                    "Access",
                    state.access,
                    "required",
                    {
                      className: "text-danger",
                    }
                  )}
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md={12} className="d-flex justify-content-center">
                  <button
                    className="btn btn-danger w-sm waves-effect waves-light"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Back
                  </button>
                  <button
                    className="btn btn-primary w-sm waves-effect waves-light ms-3"
                    type="button"
                    onClick={handleSubmit}
                  >
                    {(loader && <Spinner animation="grow" size="sm" />) ||
                      "Submit"}
                  </button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};
